import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ManagementComponent} from './management.component';

@NgModule({
  declarations: [
    ManagementComponent
  ],
  exports: [
  ],
  imports: [
    SharedModule
  ]
})
export class ManagementModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/management/management.module.ts